import { Component, OnDestroy, OnInit } from '@angular/core';
import { MyTasksService } from 'dm-src/app/modules/my-tasks/my-tasks.service';
import { ModalService } from 'shared';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-location-check-modal',
    templateUrl: './location-check-modal.component.html',
    styleUrls: ['./location-check-modal.component.scss'],
})
export class LocationCheckModalComponent implements OnInit, OnDestroy {
    private readonly componentDestroyed$ = new Subject<void>();

    center: google.maps.LatLngLiteral = { lat: 40.73061, lng: -73.935242 };

    infoWindow = new google.maps.InfoWindow({
        content: 'Cím lekérése...',
    });

    geocoder = new google.maps.Geocoder();
    address: string;

    zoom = 15;
    markers: google.maps.LatLngLiteral[] = [{ lat: 40.73061, lng: -73.935242 }];
    showMap = false;

    mapOptions: google.maps.MapOptions = {
        mapTypeId: 'roadmap',
        disableDefaultUI: false,
        zoomControl: true,
        scrollwheel: true,
        disableDoubleClickZoom: false,
        maxZoom: 40,
        minZoom: 5,
        styles: [
            {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [{ color: '#blue' }],
            },
        ],
    };

    constructor(
        private _modalService: ModalService,
        private _myTasksService: MyTasksService
    ) {}

    public get hasLocation(): boolean {
        return !!this.markers?.length;
    }

    ngOnInit(): void {
        this._myTasksService.currentPosition
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((position) => {
                if (!position) {
                    return;
                }

                this.center = { lat: position.lat, lng: position.lng };
                this.markers = [{ lat: position.lat, lng: position.lng }];
                this.showMap = false;

                const latlng = { lat: position.lat, lng: position.lng };

                this.geocoder.geocode({ location: latlng }, (results, status) => {
                    if (status === 'OK' && results?.[0]) {
                        console.log('Cím:', results[0].formatted_address);
                        this.address = results[0].formatted_address;
                    } else {
                        console.error('Geokódolás sikertelen:', status);
                        this.address = undefined;
                    }
                });
            });
    }

    ngOnDestroy(): void {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    public loadMap(): void {
        setTimeout(() => {
            this.showMap = true;
        }, 50);
    }

    public acceptLocation(): void {
        this._myTasksService.isCurrentPositionAccepted.next(true);
        this._modalService.setModalVisibility(false, 'location-check-modal');
    }

    public closeModal(): void {
        this._modalService.setModalVisibility(false, 'location-check-modal');
    }

    public onModalClose(): void {
        this._myTasksService.isCurrentPositionAccepted.next(false);
    }
}
